import { render, staticRenderFns } from "./EditRegistration.vue?vue&type=template&id=5ee5b83e&"
import script from "./EditRegistration.vue?vue&type=script&lang=js&"
export * from "./EditRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports